import useTabs from '@/hooks/useTabs'
import BadgeDollarIcons from '@/icons/BadgeDollarIcons'
import KPIIcons from '@/icons/KPIIcons'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import IncomesView from './components/Incomes'
import KPIEmployees from './components/KPIEmployees'
import Summary from './components/Summary'
import { useIncomeList } from './hooks/use-income-list'

const IncomesTab = () => {
    const {
        incomes,
        pagination,
        stateComponent,
        isFetching,
        isLoading,
        stats,
        control,
        setFilter,
        setFilters,
        searchInputProps,
        columns,
        filterItems,
        params,
        queryParams,
        EMPLOYEE_INCOME_EXCEL_COLUMNS,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useIncomeList()

    return (
        <div className="space-y-2">
            <Summary stats={stats} />
            <IncomesView
                incomes={incomes}
                pagination={pagination}
                stateComponent={stateComponent}
                isFetching={isFetching}
                isLoading={isLoading}
                columns={columns}
                filterItems={filterItems}
                control={control}
                setFilter={setFilter}
                setFilters={setFilters}
                searchInputProps={searchInputProps}
                params={params}
                queryParams={queryParams}
                excelColumns={EMPLOYEE_INCOME_EXCEL_COLUMNS}
                handleSortChange={handleSortChange}
                handlePageChange={handlePageChange}
                handlePageSizeChange={handlePageSizeChange}
                t={t}
            />
        </div>
    )
}

const Incomes = () => {
    const { t } = useTranslation('report')

    const { TabProps, TabComponent } = useTabs({
        tabs: [
            {
                label: t('incomes.title'),
                value: '',
                startIcon: <BadgeDollarIcons />,
                component: <IncomesTab />,
            },
            {
                label: t('kpis.management'),
                value: 'kpi-management',
                startIcon: <KPIIcons />,
                component: <KPIEmployees />,
            },
        ],
    })

    return (
        <div className="space-y-2">
            <Tabs {...TabProps} tabContainerClassName="mb-0" />
            {TabComponent}
        </div>
    )
}

export default Incomes
